/*
 * Input
 *
 * This is the first thing users see of our App, at the '/' route
 */


import React from 'react';
import PropTypes from 'prop-types';

import eyeIcon from 'assets/eye.svg';

import Hint from 'components/Hint';
import Label from 'components/Label';
import ToolIcon from 'components/Icons/ToolIcon';
import CharacterCounter from 'components/CharacterCounter';

import {
  iconShowStyles,
  iconHideStyles
} from 'commonThemes/iconThemes';
import InputWrapper from './styles/InputWrapper';
import InputErrorContent from './styles/InputErrorContent';
import InputHeader from './styles/InputHeader';
import InputHintContent from './styles/InputHintContent';
import InputRequireContent from './styles/InputRequireContent';
import InputContentWrapper from './styles/InputContentWrapper';
import InputHintRequireWrapper from './styles/InputHintRequireWrapper';
import InputClear from './styles/InputClear';


class Input extends React.PureComponent {
  constructor() {
    super();

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnClickInput = this.handleOnClickInput.bind(this);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleShowPassword = this.handleShowPassword.bind(this);
    this.handleClear = this.handleClear.bind(this);

    this.thisInput = React.createRef();

    this.state = {
      selectionStart: 0,
      showPassword: false,
      isTooLong: false
    };
  }

  handleClear(event) {
    this.handleOnChange(event, true);
  }


  handleOnClick() {
    if (this.props.onClick) this.props.onClick();
  }

  handleOnClickInput() {
    if (this.props.onClickInput) this.props.onClickInput();
  }

  handleOnKeyPress(event) {
    if (this.props.onKeyPress) this.props.onKeyPress(event);
  }

  handleOnKeyDown(event) {
    if (this.props.onKeyDown) this.props.onKeyDown(event);
  }

  handleOnBlur() {
    if (this.props.onBlur) this.props.onBlur(this.thisInput);
  }

  handleOnFocus() {
    if (this.props.onFocus) this.props.onFocus(this.thisInput);
  }

  handleShowPassword() {
    this.setState((prevState) => {
      return {
        showPassword: !prevState.showPassword
      };
    });
  }

  handleOnChange(event, isClear) {

    const {
      maxLength
    } = this.props;

    const hasValue = event && event.target && event.target.value;
    const isTooLong = hasValue && event.target.value.length > 500 || maxLength && hasValue && event.target.value.length > maxLength;

    if (isTooLong) this.setState({
      isTooLong: true
    });

    if (this.state.isTooLong) this.setState({
      isTooLong: false
    });

    if (!this.props.onChange) return null;

    if (this.props.type === 'file' || this.props.passEvent) {
      return this.props.onChange(isClear ? '' : event);
    } else if (this.props.updateType) {
      return this.props.onChange({
        value: isClear ? '' : event.target.value,
        updateType: this.props.updateType,
        language: this.props.language,
        type: this.props.type
      }, this.props.isValue);
    }

    return this.props.onChange(isClear ? '' : event.target.value);
  }

  componentDidUpdate() {
    if (this.props.selectionStart) this.thisInput.setSelectionRange(this.props.selectionStart, this.props.selectionStart);
  }

  componentDidMount() {
    if (this.props.isFocused) this.thisInput.focus();
  }


  render() {

    const {
      id,
      type,
      required,
      value,
      accept,
      error,
      placeholder,
      isEditable,
      multiple,
      label,
      thisStyles,
      labelStyles,
      thisStylesWrapper,
      thisStylesInputHeader,
      hidden,
      hint,
      readOnly,
      noFocus,
      disabled,
      min,
      max,
      noCaret,
      datePicker,
      maxLength,
      language = 'en',
      labelStylesCss,
      placeholderStylesCss,
      counterStyles
    } = this.props;

    const { showPassword, isTooLong } = this.state;

    const labelContent = label ? (
      <Label
        title={label}
        thisStyles={{
          ...labelStyles,
          display: 'inline',
        }}
        labelStylesCss={labelStylesCss}
      />
    ) : '';

    const thisError = isTooLong || error;

    const errorContent = thisError || isTooLong ? <InputErrorContent data-cypress={this.props['data-cypress']+'-InputErrorContent'}>{isTooLong ? 'Too many characters!' : thisError.statusText ? thisError.statusText : thisError && thisError[language] && thisError[language].statusText ? thisError[language].statusText : thisError[language] === 'string' ? thisError && thisError[language] : typeof thisError === 'string' ? thisError : 'Something is wrong...'}</InputErrorContent> : '';

    const hintContent = hint ? (
      <InputHintContent>
        <Hint message={hint} />
      </InputHintContent>
    ) : (
        ''
      );

    const requiredCondition = required && !thisError || thisError && thisError.type === 'isRequired'
    const requireContent = requiredCondition || required ? (
      <InputRequireContent>*</InputRequireContent>
    ) : '';

    const showPasswordIcon = showPassword
      ? (
        <ToolIcon
          onClick={this.handleShowPassword}
          icon={eyeIcon}
          thisStyles={{
            ...iconHideStyles,
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            height: 'unset',
            justifyContent: 'flex-end',
            width: 'fit-content'
          }}
        />
      )
      : (
        <ToolIcon
          onClick={this.handleShowPassword}
          icon={eyeIcon}
          thisStyles={{
            ...iconShowStyles,
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            height: 'unset',
            justifyContent: 'flex-end',
            width: 'fit-content'
          }}
        />
      );

    return (
      <InputContentWrapper
        hidden={hidden}
        onClick={this.handleOnClick}
        thisStyles={thisStylesWrapper ? thisStylesWrapper : {}}
      >
        {type !== 'time' && labelContent ? (<InputHeader thisStyles={thisStylesInputHeader}>
          {labelContent}
          <InputHintRequireWrapper isRequired={requiredCondition}>
            {requireContent}
            {hintContent}
          </InputHintRequireWrapper>
          {type === 'password' ? showPasswordIcon : ''}
        </InputHeader>) : ''}

        <InputWrapper
          id={id}
          multiple={multiple}
          isEditable={isEditable}
          hidden={hidden}
          ref={(thisInput) => this.thisInput = thisInput}
          accept={accept}
          type={type && !showPassword && type !== 'time' ? type : 'text'}
          name={type}
          value={value ? value : ''}
          onClick={this.onClickInput}
          onChange={this.handleOnChange}
          error={thisError ? true : false}
          datatype={datePicker}
          placeholder={placeholder}
          placeholderStylesCss={placeholderStylesCss}
          onKeyPress={this.handleOnKeyPress}
          onKeyDown={this.handleOnKeyDown}
          onBlur={this.handleOnBlur}
          onFocus={this.handleOnFocus}
          thisStyles={thisStyles ? thisStyles : {}}
          noFocus={noFocus}
          disabled={disabled}
          min={min}
          max={max}
          noCaret={noCaret}
          showPasswordIcon={showPasswordIcon}
          readOnly={readOnly}
          data-cypress={this.props['data-cypress']}
        />

        {errorContent}
        {type && type !== 'text' || !maxLength || isTooLong ? '' : (
          <CharacterCounter
            characterNum={value ? value.length : null}
            maxCharacters={maxLength}
            thisStyles={counterStyles}
          />
        )}
        {this.props.hasClear && value ? (
          <InputClear onClick={this.handleClear}>Clear</InputClear>
        ):''}
        
      </InputContentWrapper>
    );
  }
}

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  selectionStart: PropTypes.number,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  label: PropTypes.string,
  onChange: PropTypes.func,
  updateType: PropTypes.string,
  placeholder: PropTypes.string,
  isEditable: PropTypes.bool,
  multiple: PropTypes.bool,
  thisStyles: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  labelStyles: PropTypes.object,
  thisStylesWrapper: PropTypes.object,
  thisStylesInputHeader: PropTypes.object,
  hidden: PropTypes.bool,
  hint: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string
  }),
  onClick: PropTypes.func,
  onClickInput: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  noFocus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disabled: PropTypes.bool,
  noCaret: PropTypes.bool,
  isFocused: PropTypes.bool,
  passEvent: PropTypes.bool,
  language: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  accept: PropTypes.string,
  datePicker: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool
};

export default Input;
